import styled from "styled-components";
import { media } from "../../theme";

export const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 32px;

  ${media.md} { padding: 0 24px; }
  ${media.sm} { padding: 0 18px; }
`;

export const Section = styled.section`
  padding: ${(p) => (p.tight ? "72px 0" : "120px 0")};

  ${media.md} { padding: ${(p) => (p.tight ? "56px 0" : "88px 0")}; }
  ${media.sm} { padding: ${(p) => (p.tight ? "48px 0" : "72px 0")}; }
`;

export const Eyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${(p) => p.color || "#0033CC"};

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    background: currentColor;
    border-radius: 50%;
  }
`;
